import { useEffect, useState } from "react";
import { qualifyUrl } from "util/URLUtils";
import fetch from "logic/rest/FetchProvider";
const parseError = (error) => {
  const fullError = error.additional && error.additional.body && error.additional.body.message;
  return fullError || error.message;
};
const useFetch = (url, setHook = () => {
}, method = "GET", options = {}, urlWithParams = (fetchUrl) => fetchUrl) => {
  const [fetchUrl, setFetchUrl] = useState(url);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);
  const qualifiedGetURL = fetchUrl ? qualifyUrl(urlWithParams(fetchUrl, options)) : null;
  const qualifiedURL = fetchUrl ? qualifyUrl(fetchUrl) : null;
  useEffect(() => {
    let isFetchable = !!qualifiedURL;
    const fetchData = async () => {
      let fetcher = Promise.resolve();
      if (isFetchable && !data) {
        setLoading(true);
        if (method === "GET") {
          fetcher = fetch(method, qualifiedGetURL);
        } else {
          fetcher = fetch(method, qualifiedURL, {
            ...options
          });
        }
        fetcher.then((result) => {
          setError(null);
          setData(result);
          setHook(result);
        }).catch((err) => {
          setData(null);
          setError(parseError(err));
        }).finally(() => {
          setLoading(false);
        });
      }
      return fetcher;
    };
    fetchData();
    return () => {
      isFetchable = false;
    };
  }, [qualifiedURL, qualifiedGetURL]);
  return [{ loading, error, data }, setFetchUrl];
};
export default useFetch;
